import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { JedinicaMere } from './jedinica-mere';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-jedinica-mere',
  templateUrl: './jedinica-mere.component.html'
 // styleUrls: ['./jedinica-mere.component.scss']
})
export class JedinicaMereComponent extends BaseModalContainer<JedinicaMere> implements OnInit {

  constructor (
      protected modalContainerService: ModalContainerService<JedinicaMere>,
      protected activatedRoute: ActivatedRoute,
      protected modalService: ModalService,
      protected userService: UserService
  ){
      super(modalContainerService, activatedRoute, modalService, userService)
  }

  ngOnInit(){
  }
}
